import { ApplicationState, AppThunkDispatch } from '../../../store';
import { connect } from 'react-redux';
import NotificationsMenu, { NotificationsMenuStateProps, NotificationsMenuDispatchProps } from './NotificationsMenu';
import { getNotifications } from '../../../store/general/selectors';
import { Notification } from '../../../models';
import { NotificationTypeEnum } from '../../../models';
import { openEntity, openAppointment } from '../../../store/entities/actions';
import { getClientAsync, getClientOrderByIdAsync, getPackAsync } from '../../../ajax/requests';
 
const mapStateToProps = (state: ApplicationState): NotificationsMenuStateProps => ({
    notifications: getNotifications(state),
});

const mapDispatchToProps = (dispatch: AppThunkDispatch): NotificationsMenuDispatchProps => ({
    onNotificationClick: (notification: Notification) => {
        switch(notification.type) {
            case NotificationTypeEnum.ClientInactive:
            case NotificationTypeEnum.ClientFollowUp:
                dispatch(openEntity('clients', notification.entityId!, () => getClientAsync(notification.entityId!)));
                break;
            case NotificationTypeEnum.ClientRequest:
            case NotificationTypeEnum.AppointmentMissingPayment:
                dispatch(openAppointment(notification.entityId!));
                break;
            case NotificationTypeEnum.PackMissingPayment:
                dispatch(openEntity('clientPacks', notification.entityId!, () => getPackAsync(notification.entityId!)));
                break;
            case NotificationTypeEnum.OrderMissingPayment:
                dispatch(openEntity('orders', notification.entityId!, () => getClientOrderByIdAsync(notification.entityId!) as any));
                break;
        }
    },
});

export default connect<NotificationsMenuStateProps, NotificationsMenuDispatchProps, void, ApplicationState>(
    mapStateToProps,
    mapDispatchToProps,
)(NotificationsMenu as any);
